export default __webpack_public_path__ + "static/media/pkb-1.da21e590.png";